// @flow
import React from 'react';
import type { BusinessCalendarForBudget } from '../../../../../../../lib/types';

export const WorkDaysCalendarContext = React.createContext<
  BusinessCalendarForBudget[]
>([]);
